module.exports = __webpack_public_path__ + "static/media/Cats Eyes 01_TYSKA-mixdown.de350a9b.mp3";